import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { LabelValue } from "../../../core/models/label-value";
import { MaterialModule } from "../../../core/shared/material.module";

/**
 * A reusable component to display icons with optional customization. The component supports displaying
 * material icons, custom icons, and Google icons with customizable styles.
 */
@Component({
  selector: "app-icon",
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: "./icon.component.html",
  styleUrl: "./icon.component.scss",
})
export class IconComponent {
  @Input()
  name!: LabelValue | null | undefined;

  @Input()
  icon = "info";

  @Input()
  iconPath: any;

  @Input()
  customStyle!: any;

  @Input()
  isGoogleIcon = false;

  @Input()
  isFilled = false;
}
